import React from "react";
import styles from "./RatingStarDisplay.module.css";

const RatingStarDisplay = ({ rating }) => {
  // Handle null, undefined, or non-numeric values
  if (rating == null || isNaN(rating)) {
    return <div className={styles.stars} />;
  }

  const fullStars = Math.floor(rating); // Count of full stars
  const hasHalfStar = rating % 1 !== 0; // Check if there's a half star
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

  return (
    <div className={styles.stars}>
      <span className={styles.ratingLabel}>{rating.toFixed(1)}</span>

      {/* Full Stars */}
      {[...Array(fullStars)].map((_, i) => (
        <span key={i} className={`${styles.star} ${styles.filled}`}>
          ★
        </span>
      ))}

      {/* Half Star */}
      {hasHalfStar ? <span className={`${styles.star} ${styles.half}`}>★</span> : null}

      {/* Empty Stars */}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={i + fullStars} className={`${styles.star} ${styles.empty}`}>
          ★
        </span>
      ))}
    </div>
  );
};

export default RatingStarDisplay;
